import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {StateService} from "../../services/StateService";
import {NewTpiqService} from "../../tpiq-services/new-tpiq.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {CreateOrUpdateAnnouncementComponent} from "./create-or-update-announcement/create-or-update-announcement.component";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-announcements',
  standalone: true,
  imports: [CommonModule, FormsModule, CreateOrUpdateAnnouncementComponent],
  templateUrl: './announcements.component.html',
  styleUrl: './announcements.component.scss'
})
export class AnnouncementsComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  columns: Array<any> = [
    {name: 'name', title: 'Name', type: 'html', classes: 'pointer zero-overflow', sortable: true},
    {name: 'description', title: 'Description', type: 'html', classes: 'pointer zero-overflow tracker-desc', sortable: true}
  ];
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  announcementsList: Array<any> = [];
  announcementId: any;
  reveal: any = {
    addOrEditAnnouncement: false,
  };
  editMode = false;
  editorOptions = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Enter description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };

  constructor(
    private _router: Router,
    private loadingService: LoadingService,
    private stateService: StateService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private newTpiqService: NewTpiqService
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.getAnnouncementsList();
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data) {
        this.removeAnnouncement(toast.data);
      }
    });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getAnnouncementsList() {
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.getAnnouncementsList(this.org, this.user.id).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.announcementsList = response;
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed to get announcements data`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  navigateToAnnouncementPage(data) {
    this.announcementId = data.id;
    this.editMode = true;
    this.reveal.addOrEditAnnouncement = true;
  }

  createNewAnnouncement() {
    this.editMode = false;
    this.reveal.addOrEditAnnouncement = true;
  }

  hideReveal(key){
    this.reveal[key] = false;
  }

  deleteAnnouncement(announcement) {
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', announcement);
  }

  removeAnnouncement(announcement) {
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.removeAnnouncement(this.org, this.user.id, announcement.id)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Announcement deleted successfully');
        this.getAnnouncementsList();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to delete announcement`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  refreshListOfAnnouncements() {
    this.reveal.addOrEditAnnouncement = false;
    this.getAnnouncementsList();
  }

}
